import { createSelector } from 'reselect';
import { AppState } from 'store/types/Store';
import { getCurrentSeason } from './seasonSelectors';

const getHarvest = (state: AppState) => state.harvest;

export const getHarvestState = createSelector(
  [getHarvest, getCurrentSeason],
  (harvestState, currentSeasonId) => harvestState[currentSeasonId]);
